var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Box, FormControl, FormLabel, Switch, HStack, Input, VStack, Flex, Button, } from "@reverb-ui/react";
import React, { useContext, useEffect } from "react";
import { RequiredIndicator } from "@/features/first-access/presentation/components/required-indicator";
import { useForm, useWatch } from "react-hook-form";
import { CompanyWizardContext } from "@/features/first-access/presentation/context-api/company-wizard-provider";
import { AuthContext } from "@/shared/presentation/context-api/providers/auth";
export var CompanyProfileForm = function (_a) {
    var hasNextStep = _a.hasNextStep, hasPreviousStep = _a.hasPreviousStep, goToNextStep = _a.goToNextStep, goToPrevStep = _a.goToPrevStep;
    var _b = useContext(CompanyWizardContext), setCompanyUserProfile = _b.setCompanyUserProfile, companyUserProfile = _b.companyUserProfile;
    var user = useContext(AuthContext).user;
    var _c = useForm(companyUserProfile && {
        defaultValues: __assign(__assign({}, companyUserProfile), { usePreferredName: !!companyUserProfile.preferredName, email: user === null || user === void 0 ? void 0 : user.email }),
    }), register = _c.register, control = _c.control, handleSubmit = _c.handleSubmit, setValue = _c.setValue;
    useEffect(function () {
        setValue("email", user.email);
    }, [user.email, setValue]);
    var formValues = useWatch({ control: control });
    var nameValidator = {
        required: true,
    };
    var emailValidator = {
        required: true,
    };
    var submit = function (values) {
        var _a;
        var email = values.email, name = values.name, preferredName = values.preferredName, usePreferredName = values.usePreferredName;
        setCompanyUserProfile({
            email: email,
            name: name,
            preferredName: getPreferredName(usePreferredName, preferredName),
            document: (_a = user.entity) === null || _a === void 0 ? void 0 : _a.document,
        });
        goToNextStep();
    };
    var getPreferredName = function (usePreferredName, preferredName) {
        if (!usePreferredName) {
            return undefined;
        }
        return preferredName;
    };
    return (React.createElement(Box, { w: "full" },
        React.createElement("form", null,
            React.createElement(VStack, { spacing: 8 },
                React.createElement(HStack, { w: "full", spacing: 5 },
                    React.createElement(FormControl, { isRequired: true },
                        React.createElement(FormLabel, { requiredIndicator: React.createElement(RequiredIndicator, null), fontSize: "sm" }, "Name"),
                        React.createElement(Input, __assign({}, register("name", nameValidator)))),
                    React.createElement(FormControl, { isRequired: true },
                        React.createElement(FormLabel, { requiredIndicator: React.createElement(RequiredIndicator, null), fontSize: "sm" }, "E-mail"),
                        React.createElement(Input, __assign({ isDisabled: true }, register("email", emailValidator))))),
                React.createElement(HStack, { w: "full", alignItems: "start" },
                    React.createElement(FormControl, { flex: 1 },
                        React.createElement(Flex, { pt: 4 },
                            React.createElement(FormLabel, { fontSize: "sm" }, "Uses a preferred name"),
                            React.createElement(Switch, __assign({}, register("usePreferredName"))))),
                    React.createElement(Box, { flex: 1, minH: "70px" }, formValues.usePreferredName && (React.createElement(FormControl, { isRequired: true },
                        React.createElement(FormLabel, { requiredIndicator: React.createElement(RequiredIndicator, null), fontSize: "sm" }, "Preferred name"),
                        React.createElement(Input, __assign({}, register("preferredName", nameValidator))))))))),
        React.createElement(Flex, { justifyContent: "space-between", pt: 8, pb: 3 },
            React.createElement(Box, null, hasPreviousStep && (React.createElement(Button, { colorScheme: "blue", onClick: goToPrevStep }, "Previous"))),
            React.createElement(Flex, null, hasNextStep && (React.createElement(Button, { colorScheme: "blue", onClick: handleSubmit(submit) }, "Next"))))));
};
